import { ApiDetailResponse } from "../common/interfaces/ApiResponse";
import { NotificationType } from "../common/types/serviceType";
import { apiSlice } from "./apiSlice";

const notificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotifications: builder.query<
      ApiDetailResponse<{ updatedNotifications: NotificationType[] }>,
      string
    >({
      query: () => ({
        url: `/notification/getMyOldNotifications`,
      }),
    }),
    readAllNotifications: builder.mutation({
      query: () => ({
        url: `/notification/markAllAsRead`,
        method: "PATCH",
      }),
    }),
    addNewsletter: builder.mutation({
      query: (body: { email: string; subscriptionDate: string }) => ({
        url: "/newsletter/addNewsletter",
        method: "POST",
        body,
      }),
    }),
  }),
});
export const {
  useGetAllNotificationsQuery,
  useReadAllNotificationsMutation,
  useAddNewsletterMutation,
} = notificationApi;
